import { TextField } from '@mui/material';
import { useLanguage } from '../../../../contexts/language';
import { OperatorPartialFormProps } from '../types';
import FormLayout, {
  FormLayoutInputElement,
} from '../../../../components/FormLayout';

const OperatorBasicInformationForm = ({
  formManager,
}: OperatorPartialFormProps) => {
  const { t } = useLanguage();
  const {
    materialInputHelpers: { getTextFieldProps },
  } = formManager;
  return (
    <FormLayout>
      <FormLayoutInputElement required label={t('content.company-name')}>
        <TextField
          {...getTextFieldProps('companyName')}
          placeholder={t('content.company-name')}
        />
      </FormLayoutInputElement>
      <FormLayoutInputElement label={t('content.website')}>
        <TextField
          {...getTextFieldProps('website')}
          placeholder={t('content.website')}
        />
      </FormLayoutInputElement>
      <FormLayoutInputElement required label={t('content.trn-vat-no')}>
        <TextField
          {...getTextFieldProps('trnVatNumber')}
          placeholder={t('content.trn-vat-no')}
        />
      </FormLayoutInputElement>
      <FormLayoutInputElement label="TCAN">
        <TextField {...getTextFieldProps('tcanNumber')} placeholder="TCAN" />
      </FormLayoutInputElement>
      <FormLayoutInputElement label="CRO.">
        <TextField {...getTextFieldProps('croNumber')} placeholder="CRO." />
      </FormLayoutInputElement>
    </FormLayout>
  );
};

export default OperatorBasicInformationForm;
